export const CLEAR_CONTACT = 'app/TeamManagementUsers/CLEAR_CONTACT'
export const CLEAR_CONTACT_LIST = 'app/TeamManagementUsers/CLEAR_CONTACT_LIST'

export const CREATE_CONTACT = 'app/TeamManagementUsers/CREATE_CONTACT'
export const CREATE_CONTACT_DONE = 'app/TeamManagementUsers/CREATE_CONTACT_DONE'
export const CREATE_CONTACT_ERROR =
  'app/TeamManagementUsers/CREATE_CONTACT_ERROR'

export const GET_CONTACT_BY_ID = 'app/TeamManagementUsers/GET_CONTACT_BY_ID'
export const GET_CONTACT_BY_ID_DONE =
  'app/TeamManagementUsers/GET_CONTACT_BY_ID_DONE'
export const GET_CONTACT_BY_ID_ERROR =
  'app/TeamManagementUsers/GET_CONTACT_BY_ID_ERROR'

export const UPDATE_CONTACT = 'app/TeamManagementUsers/UPDATE_CONTACT'
export const UPDATE_CONTACT_DONE = 'app/TeamManagementUsers/UPDATE_CONTACT_DONE'
export const UPDATE_CONTACT_ERROR =
  'app/TeamManagementUsers/UPDATE_CONTACT_ERROR'

export const DELETE_CONTACT = 'app/TeamManagementUsers/DELETE_CONTACT'
export const DELETE_CONTACT_DONE = 'app/TeamManagementUsers/DELETE_CONTACT_DONE'
export const DELETE_CONTACT_ERROR =
  'app/TeamManagementUsers/DELETE_CONTACT_ERROR'

export const GET_PROJECTS_TEAM = 'app/TeamManagementUsers/GET_PROJECTS_TEAM'
export const GET_PROJECTS_TEAM_DONE =
  'app/TeamManagementUsers/GET_PROJECTS_TEAM_DONE'
export const GET_PROJECTS_TEAM_ERROR =
  'app/TeamManagementUsers/GET_PROJECTS_TEAM_ERROR'

export const GET_PROJECT_CONTACTS =
  'app/TeamManagementUsers/GET_PROJECT_CONTACTS'
export const GET_PROJECT_CONTACTS_DONE =
  'app/TeamManagementUsers/GET_PROJECT_CONTACTS_DONE'
export const GET_PROJECT_CONTACTS_ERROR =
  'app/TeamManagementUsers/GET_PROJECT_CONTACTS_ERROR'

export const ADD_NEW_MEMBERS = 'app/TeamManagementUsers/ADD_NEW_MEMBERS'
export const ADD_NEW_MEMBERS_ERROR =
  'app/TeamManagementUsers/ADD_NEW_MEMBERS_ERROR'

export const INVITE_CONTACT_TO_MEMBERS =
  'app/TeamManagementUsers/INVITE_CONTACT_TO_MEMBERS'
export const INVITE_CONTACT_TO_MEMBERS_DONE =
  'app/TeamManagementUsers/INVITE_CONTACT_TO_MEMBERS_DONE'
export const INVITE_CONTACT_TO_MEMBERS_ERROR =
  'app/TeamManagementUsers/INVITE_CONTACT_TO_MEMBERS_ERROR'

export const UPDATE_MEMBER = 'app/TeamManagementUsers/UPDATE_MEMBER'
export const UPDATE_MEMBER_DONE = 'app/TeamManagementUsers/UPDATE_MEMBER_DONE'
export const UPDATE_MEMBER_ERROR = 'app/TeamManagementUsers/UPDATE_MEMBER_ERROR'

export const REMOVE_MEMBERS = 'app/TeamManagementUsers/REMOVE_MEMBERS'
export const REMOVE_MEMBERS_DONE = 'app/TeamManagementUsers/REMOVE_MEMBERS_DONE'
export const REMOVE_MEMBERS_ERROR =
  'app/TeamManagementUsers/REMOVE_MEMBERS_ERROR'

export const IMPORT_CONTACTS_DONE =
  'app/TeamManagementUsers/IMPORT_CONTACTS_DONE'
export const CHANGE_SORT = 'app/TeamManagementUsers/CHANGE_SORT'
export const CHANGE_CONTACT_SORT = 'app/TeamManagementUsers/CHANGE_CONTACT_SORT'

export const importFieldAttributes = [
  'FirstName',
  'LastName',
  'CompanyName',
  'Email',
  'Phone',
  'Fax',
  'JobTitle',
  'Department',
  'Street',
  'Zip',
  'City',
  'CountryCode',
  'Ignore'
]
